/* eslint-disable max-len */
const th = {
  seo: {
    // eslint-disable-next-line max-len
    keywords: 'BiliBili,อนิเมะฟรี,การ์ตูน，อนิเมะสั้น,อนิเมะยอดนิยม,Y,วาย,อนิเมะยูริ,wetv,iqiyi,crunchyroll,ดาบพิฆาตอสูร,ผ่าพิภพไททัน,เกิดใหม่ทั้งทีก็เป็นสไลม์ไปซะแล้ว ภาคที่สอง,จะยังไงภรรยาผมก็น่ารัก,เกิดชาตินี้พี่ต้องเทพ,สวรรค์ประทานพร,คอสเพลย์,ซับไทย',
  },
  common: {
    more: 'เพิ่มเติม',
    confirm: 'ยืนยัน',
    cancel: 'ยกเลิก',
    home: 'หน้าหลัก',
    clickToMove: 'คลิกเพื่อลาก'
  },
  follow: {
    follow: 'ติดตาม',
    following: 'ติดตามแล้ว',
  },
  roomInfo: {
    share: 'แชร์',
    copySucceed: 'คัดลอกลิงก์หน้าสำเร็จ',
    copyFailed: 'คัดลอกลิงก์หน้าล้มเหลว',
    liveClosed: 'ไลฟ์สดยังไม่เริ่ม',
    viewer: 'ผู้ชม {count} คน',
  },
  roomVideo: {
    controlBar: {
      play: 'เล่นเลย',
      pause: 'หยุดชั่วคราว',
      refresh: 'รีเฟรช',
      refreshSucceed: 'รีเฟรชสำเร็จ',
      refreshFailed: 'รีเฟรชล้มเหลว',
      refreshing: 'กำลังรีเฟรช',
      fullscreen: 'โหมดเต็มจอ',
      exitFullscreen: 'ออกจากโหมดเต็มจอ',
      switchQning: 'กำลังเปลี่ยนความละเอียดเป็น',
      switchQnFailed: 'การเปลี่ยนระดับความละเอียดล้มเหลว กรุณาลองอีกครั้ง',
      switchQnSucceed: 'เปลี่ยนความละเอียดเป็น ',
    },
  },
  comment: {
    title: 'Danmaku',
    sender_input_placeholder: 'ส่ง Danmaku สิ ~',
    sended_send: 'ส่ง',
    new_messages: 'อัปเดต {count} Danmaku',
    login_before_send: 'เข้าสู่ระบบเพื่อเข้าร่วมการส่ง Danmaku แสนสนุก',
    // eslint-disable-next-line max-len
    default_welcome: 'ยินดีต้อนรับเข้าสู่ห้องไลฟ์! เราสนับสนุนเนื้อหาที่สร้างสรรค์และมีความหลากหลาย ในขณะเดียวกันเราจะใช้มาตรการที่จำเป็นเพื่อป้องกันและหยุดการละเมิดกฎหมายของข้อบังคับต่าง ๆ ข้อกำหนดและจริยธรรมในท้องถิ่น การละเมิดสิทธิ์ทางกฎหมายของผู้อื่น รวมถึงเนื้อหาใด ๆ ที่อาจส่งผลต่อความปลอดภัยและสุขภาพของการเผยแพร่ในชุมชน นอกจากนี้ อาจมีการรายงานการละเมิดกฎหมายต่อหน่วยงานควบคุมดูแล เพื่อดำเนินการจัดการตามข้อกำหนดของกฎหมายและข้อบังคับใช้'
  },
  rank: {
    title: 'อันดับผู้ใช้',
    login: 'เข้าสู่ระบบ',
    viewRank: ' เพื่อดูอันดับของคุณ',
    toContribute: 'ส่ง Star เพื่อติดอันดับทันที',
    myScore: 'มูลค่าการสนับสนุน',
    noData: 'มาติดอันดับและสนับสนุนสตรีมเมอร์เลย !',
  },
  gift: {
    all: 'ทั้งหมด ของขวัญ',
    topUp: 'เติมเงิน',
    top: 'ฮอต',
    starDesc: 'ผู้ใช้สามารถรับ Star ได้โดยการซื้อ และอุปกรณ์ที่ Star แลกมาจะทำให้สตรีมเมอร์รับรายได้',
  },
  introduction: {
    title: 'คำแนะนำโดยย่อการไลฟ์สด',
  },
  balance: {
    insufficientTitle: 'จำนวนไม่เพียงพอ',
    insufficientContent: 'จำนวน Star ไม่เพียงพอ กรุณาเติมเพิ่ม',
    buy: 'ไปเติม',
  },
  payment: {
    title: 'ซื้อ Star',
    balance: 'Stars ของฉัน',
    next: 'ชำระเงินทันที',
    agree: 'เมื่อคลิก "ชำระเงินทันที" จะถือว่าคุณยอมรับ',
    agreement: 'ข้อตกลงการเติม Star',
    repay: 'ชำระเงินอีกครั้ง',
    getPaid: 'ชำระเงินสำเร็จ',
    orderTitle: 'กรุณาชำระเงินให้สำเร็จที่หน้าต่างใหม่',
    methodTitle: 'เลือกวิธีชำระเงิน',
    exchangeRateDesc: 'ราคาในการซื้อ Star ขึ้นอยู่กับอัตราแลกเปลี่ยนและช่องทางการชำระเงิน',
    orderDesc: 'อย่าปิดหน้าต่างนี้จนกว่าจะทำการชำระเงินสำเร็จ เมื่อชำระเงินสำเร็จแล้ว กรุณากดปุ่มด้านล่าง',
    toast_success: 'การชำระเงินสำเร็จ',
    toast_fail: 'การชำระเงินล้มเหลว',
    toast_notPay: 'การชำระเงินไม่เสร็จ',
    toast_cancel: 'ยกเลิกการชำระเงิน',
    toast_timeout: 'หมดเวลาชำระเงิน',
  },
  home: {
    live: 'ไลฟ์สด',
    liveNow: 'กำลังไลฟ์สด',
    refresh: 'รีเฟรช',
    refreshFailed: 'การรีเฟรชล้มเหลว กรุณาลองอีกครั้ง',
    loadMore: 'กำลังประมวลผล ...',
    noMore: 'ไม่มีเนื้อหาเพิ่มเติม',
    clickToLive: 'คลิกเพื่อถ่ายทอดสด'
  },
  userCard: {
    followers: '{count} ผู้ติดตาม',
    videos: '{count} วิดีโอ',
    promote: 'เลื่อนขั้นเป็นผู้ดูแลห้องไลฟ์สด',
    demote: 'ปลดออกผู้ดูแลห้องไลฟ์สดรายนี้',
    mute: 'ปิดเสียงผู้ใช้รายนี้',
    unmute: 'ปลดแบนผู้ใช้รายนี้',
  },
  modals: {
    muteConfirm: 'หลังจากที่ผู้ใช้ถูกปิดเสียงจะไม่สามารถส่ง Danmaku ได้ ยืนยันการปิดเสียง {username} หรือไม่ ?',
    muteSuccess: 'ผู้ใช้รายนี้ถูกปิดเสียงแล้ว',
    unmuteConfirm: 'ยืนยันการปลดแบน {username} หรือไม่ ?',
    unmuteSuccess: 'ปลดแบนสำเร็จ',
    promoteConfirm: 'ตั้งให้ผู้ใช้ {username} เป็นผู้ดูแลห้องไลฟ์สดของคุณ ต้องการยืนยันคำสั่งแต่งตั้งหรือไม่ ?',
    promoteSuccess: '{username} ได้ถูกสตรีมเมอร์ตั้งให้เป็นผู้ดูแลห้องไลฟ์สด',
    demoteConfirm: 'ผู้ใช้ {username} จะไม่ใช่ผู้ดูแลห้องไลฟ์สดของคุณอีกต่อไป ยืนยันการปลดออกหรือไม่ ?',
    demoteSuccess: 'ปลดออกสำเร็จ',
  },
  chargeStrip: {
    tabProgress: 'Total Charging',
    consumeStar: 'ใช้ Star หรือทำภารกิจให้สำเร็จ เพื่อรับค่าพลังงานสำหรับเข้าร่วมสุ่มรางวัลจากแถบเติมพลังงาน',
    consumeReward: 'ทุกครั้งที่คุณใช้ 1 Star ในห้องไลฟ์สด คุณจะสามารถเพิ่มค่าพลังงานของห้องบริโภคและแถบยอดเติมพลังงาน 1 แต้ม',
    followRoom: 'ติดตามห้องไลฟ์สด',
    followRoomAward: 'เพิ่มค่าพลังงาน 3 แต้มสำหรับห้องไลฟ์สดที่ติดตามและแถบยอดเติมพลังงาน',
    sendDanmaku: 'ส่ง Danmaku 1 ข้อความไปยังห้องไลฟ์สดวันนี้',
    sendDanmakuAward: 'เพิ่มค่าพลังงาน 1 แต้มสำหรับห้องไลฟ์สดที่ส่งและแถบยอดเติมพลังงาน',
    watchLive10M: 'รับชมไลฟ์สด 1 ห้องเป็นเวลารวมทั้งสิ้น 10 นาที',
    watchLive10MAward: 'เพิ่มค่าพลังงาน 1 แต้มสำหรับห้องไลฟ์สดที่รับชมและแถบยอดเติมพลังงาน',
    watchLive30M: 'รับชมไลฟ์สด 1 ห้องเป็นเวลารวมทั้งสิ้น 30 นาที',
    watchLive30MAward: 'เพิ่มค่าพลังงาน 3 แต้มสำหรับห้องไลฟ์สดที่รับชมและแถบยอดเติมพลังงาน',
    watchLive120M: 'รับชมไลฟ์สด 1 ห้องเป็นเวลารวมทั้งสิ้น 120 นาที',
    watchLive120MAward: 'เพิ่มค่าพลังงาน 15 แต้มสำหรับห้องไลฟ์สดที่รับชมและแถบยอดเติมพลังงาน',
    watchLive: 'รับชมไลฟ์สด 1 ห้องเป็นเวลารวมทั้งสิ้น 10/30/120 นาที',
    watchLiveAward: 'เพิ่มค่าพลังงาน 1/3/15 แต้มสำหรับห้องไลฟ์สดที่รับชมและแถบยอดเติมพลังงาน',

    tabTask: 'Charging Tasks',
    uAddRoomEnergy: 'ค่าการเติมพลังงานสะสมจากห้องไลฟ์สดของคุณในปัจจุบันคือ :',
    uAddStationEnerygy: 'ค่าการเติมพลังงานสะสมจากห้องไลฟ์สดของคุณในปัจจุบันคือ :',
    // eslint-disable-next-line max-len
    consumeStarInRoom: 'ทุกครั้งที่ใช้ 1 Star ในห้องไลฟ์สดห้องนี้ จะสามารถเพิ่มค่าพลังงานของห้องนี้และแถบยอดเติมพลังงานได้ 1 แต้ม',

    tabRule: 'Rules',
    ruleDesc: `ใช้ Star/ทำภารกิจที่สอดคล้องกับ LV เพื่อรับค่าพลังงาน
    เมื่อแถบเติมพลังงานเต็ม จะสามารถเข้าร่วมการสุ่มรางวัลจากแถบเติมพลังงานของ LV ที่กำหนดไว้ได้
    สำหรับรายละเอียดของรางวัลที่เฉพาะเจาะจง กรุณาตรวจสอบที่ "ประวัติการรับรางวัล" ที่มุมขวาบน`,
    prizesBoth: 'รางวัลที่กำหนดไว้สำหรับห้องไลฟ์สดและแถบแถบยอดเติมพลังงาน :',
    prizeRoom: 'แถบเติมพลังงานห้องไลฟ์สด',
    prizeStation: 'แถบยอดเติมพลังงาน',
    avatarFrames: 'กรอบรูปโปรไฟล์',
    premium: 'Premium',
    winningRecords: 'ประวัติการรับรางวัล'
  },
  blindBoxAward: {
    title: 'ประวัติการรับรางวัล',
    stars: 'รางวัล (Star)',
    send: 'ส่ง',
    andWon: 'แล้วสุ่มได้รางวัล ',
    to: 'มอบให้',
    noReward: 'ไม่มีประวัติการรับรางวัล',
  }
};

export default th;
